<template>
  <div class="login-page">
    <!-- <div class="login_mask">
      <div style="width: 60%;height: 100%;margin: 10% auto;">
        <div style="width: 90%;height: 15%;margin: 1% auto;color: white;font-size: 20px;text-align: center;">
          权益金管理系统
        </div>
        <el-form ref="form" :model="form" label-position="left" @submit.native.prevent>
          <el-form-item label="">
            <el-input style="" prefix-icon="el-icon-user
                    " v-model="form.auAccount" placeholder="请输入用户名"></el-input>
          </el-form-item>
          <div style="margin-top: 5%;">
            <el-form-item label="">
              <el-input style="" prefix-icon="el-icon-lock
                      " show-password v-model="form.auPw" placeholder="请输入密码"></el-input>
            </el-form-item>
          </div>

          <el-button type="primary" plain style="width: 100%;" @click="login">
            立即登录
          </el-button>
        </el-form>
      </div>
    </div> -->

    <div class="login-container">
      <!-- 顶部标题区域 -->
      <div class="login-header">
        <div class="logo-icon">
          <svg t="1768200578733" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
            p-id="4802" width="128" height="128">
            <path
              d="M856.3 64.5H167.7c-57 0-103.3 46.2-103.3 103.3v688.5c0 57 46.2 103.3 103.3 103.3h688.5c57 0 103.3-46.2 103.3-103.3V167.7c0-57-46.2-103.2-103.2-103.2zM250.6 533.4C318.1 506.1 359 469 381.3 413.2h-68.8c-23.5 0-44 1.2-58.8 3.7v-39.6c13.6 2.5 32.8 3.7 57 3.7h79.9c4.3-22.3 5-27.2 6.2-62.5h-64.4c-11.7 16.7-21.7 28.5-42.1 48.3-10.5-11.8-13.6-14.9-27.3-22.9 41.5-34 65.7-69.3 78-115.2l37.2 10.5c-2.5 4.3-3.1 4.9-5 9.9-6.2 11.8-11.1 22.3-19.2 36.6h118.3c24.8 0 42.7-1.3 57.6-3.7v39.6c-17.3-2.5-33.5-3.1-56.4-3.1H432c-1.9 37.8-2.5 39.6-6.2 62.5H489c23.6 0 40.3-1.2 55.7-3.7v39.6c-15.5-2.5-32.8-3.7-55.1-3.7h-72.5c-1.2 3.7-1.2 3.7-3.1 9.3 31.6 14.9 79.9 42.1 118.3 66.9l-21.7 32.8c-35.9-29.7-58.2-44.6-108.4-72.5-26 48.3-65 83.6-125.7 113.4-6.7-11.8-12.2-18.6-25.9-29.7z m423.7 261.9v-29.7H384.4v29.7h-41.5c2.5-15.5 3.7-34.6 3.7-63.1V602.7c0-34.1-0.6-50.2-2.5-68.1 19.8 1.9 36.5 2.5 66.9 2.5h236.6c30.4 0 46.5-0.6 66.9-2.5-1.8 19.2-2.5 32.2-2.5 68.1v129.5c0 31 1.2 47 3.7 63.1h-41.4z m99.1-298.5c-15.5-1.9-27.9-2.5-50.2-2.5H612.9c-22.9 0-35.3 0.6-51.4 2.5 1.9-16.7 2.5-26.6 2.5-45.8V327.2c0-20.5-0.6-33.5-2.5-50.8 15.5 1.8 27.9 2.5 51.4 2.5h109c24.2 0 35.9-0.7 51.4-2.5-1.9 15.5-2.5 29.1-2.5 50.1v122c0.1 20.5 0.7 33.5 2.6 48.3z"
              fill="#6c42e8" p-id="4803"></path>
            <path d="M601.2 312.3h131.9v149.3H601.2zM384.4 571.1h289.9v61.3H384.4zM384.4 665.3h289.9v66.3H384.4z"
              fill="#6c42e8" p-id="4804"></path>
          </svg>
        </div>
        <h1>智课通管理系统</h1>
        <p>AI赋能智慧课纲管理平台</p>
      </div>

      <!-- Element-UI 表单区域 -->
      <el-form class="login-form" :model="form" :rules="loginRules" ref="loginFormRef">
        <!-- 用户名输入框 -->
        <el-form-item prop="auAccount">
          <label class="form-label">用户名</label>
          <el-input v-model="form.auAccount" placeholder="请输入用户名" prefix-icon="el-icon-user"
            :class="{ 'input-active': isUsernameFocus }" @focus="isUsernameFocus = true"
            @blur="isUsernameFocus = false"></el-input>
        </el-form-item>

        <!-- 密码输入框 -->
        <el-form-item prop="auPw">
          <label class="form-label">密码</label>
          <el-input v-model="form.auPw" type="password" placeholder="请输入密码" prefix-icon="el-icon-lock"
            :class="{ 'input-active': isPasswordFocus }" @focus="isPasswordFocus = true"
            @blur="isPasswordFocus = false"></el-input>
        </el-form-item>

        <!-- 登录按钮 -->
        <el-form-item>
          <el-button type="primary" class="login-btn" @click="login">
            登录系统
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>

import { mapState, mapMutations, mapAction } from 'vuex'
import {
  doLogin
} from "../api/api";
export default {
  name: 'doLogin',
  data() {
    return {
      username: "",
      password: "",
      isUsernameFocus: false,
      isPasswordFocus: false,
      loginHeight: '',
      form: {
        auAccount: "",
        auPw: null,
      },
      loginRules: {
        auAccount: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        auPw: [
          { required: true, message: "请输入密码", trigger: "blur" },
        ]
      },
    }
  },
  mounted() {
    // 监听键盘事件
    window.addEventListener('keydown', this.keyDown)
  },
  destroyed() {
    window.removeEventListener('keydown', this.keyDown, false)
  },
  methods: {
    ...mapMutations(['changeuser']),
    keyDown(e) {
      console.log(e)
      if (e.key == 'Enter') {
        this.login();
        e.preventDefault()//去掉默认的换行
      }
    },
    login() {
      if (this.form.auAccount == '' || this.form.auPw == '') {
        this.$message({
          showClose: true,
          message: '请输入用户名和密码',
          type: 'danger'
        });
      }
      // const s = qs.stringify(this.form)
      doLogin(this.form).then(res => {
        if (res.status == 200) {
          this.$notify({
            title: '成功',
            message: '登录成功',
            type: 'success'
          });
          this.changeuser({ user: res.data })
          this.$router.push({
            path: '/loading'
          })
        } else {
          this.$notify.error({
            title: '错误',
            message: res.msg
          });
        }

      })
    }
  },
  created() {
    this.loginHeight = window.innerHeight
    document.title = '智课通管理系统';
    if (localStorage.getItem('zhikeTong_token')) {
      this.$router.push({
        path: '/Home'
      })
    }
  },
  mounted() {
    if (this.loginHeight < 800) {
      var oDiv = document.querySelector('.login_mask')
      oDiv.style.height = "55%";
      oDiv.style.width = "30%";


    }
  },
  activated() {


    document.title = '智课通管理系统'

  },
  watch: {
    '$route'(to, from) {
      this.$router.go(0);
    }
  },
}
</script>

<style scoped="scoped">
/* 页面容器 - 保留你的原有背景动画 */
.login-page {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: linear-gradient(45deg, #2c3e50, #27ae60, #2980b9, #8e44ad);
  background-size: 400%;
  animation: bganimation 15s infinite;
}

/* 登录框容器 - 新增渐变动画+磨砂效果 */
.login-container {
  width: 400px;
  background: rgba(255, 255, 255, 0.15);
  /* 半透明底色 */
  backdrop-filter: blur(10px);
  /* 磨砂玻璃效果 */
  -webkit-backdrop-filter: blur(10px);
  /* 兼容webkit内核 */
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  /* 细白边增强层次感 */
  overflow: hidden;
  /* 登录框专属渐变动画 - 低饱和度+慢速度 */
  background-image: linear-gradient(135deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.08));
  background-size: 300%;
  animation: loginBgAnimation 25s infinite reverse;
  /* reverse 反向动画，和页面区分 */
}

/* 顶部标题区域 - 调整背景为半透明渐变 */
.login-header {
  background: linear-gradient(135deg, rgba(59, 115, 224, 0.8), rgba(108, 66, 232, 0.8));
  padding: 30px 20px;
  text-align: center;
  color: #fff;
}

.logo-icon {
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  margin: 0 auto 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.login-header h1 {
  font-size: 22px;
  margin: 0 0 8px;
}

.login-header p {
  font-size: 14px;
  opacity: 0.9;
  margin: 0;
}

/* 表单区域 */
.login-form {
  padding: 30px 20px;
}

.el-form-item {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  font-size: 14px;
  color: #fff;
  /* 文字改为白色，适配登录框背景 */
  margin-bottom: 8px;
}

/* 输入框激活动画 */
.el-input.input-active {
  --el-input-border-color: #fff;
}

.el-input.input-active .el-input__wrapper {
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
  border-color: #fff !important;
}

.el-input__wrapper {
  transition: all 0.3s ease;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.1) !important;
  /* 输入框底色半透明 */
  border-color: rgba(255, 255, 255, 0.2) !important;
}

.el-input__inner {
  color: #fff !important;
  /* 输入框文字白色 */
}

.el-input__inner::placeholder {
  color: rgba(255, 255, 255, 0.7) !important;
  /* 占位符浅白色 */
}

/* 按钮样式 */
.login-btn {
  width: 100%;
  height: 44px;
  background: linear-gradient(135deg, rgba(59, 115, 224, 0.9), rgba(108, 66, 232, 0.9)) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  border-radius: 6px !important;
  font-size: 16px !important;
  transition: all 0.3s ease;
}

.login-btn:hover {
  opacity: 0.9;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.login {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  margin: 0;
  padding: 0;
  font-family: "montserrat";
  background-image: linear-gradient(45deg, #2c3e50, #27ae60, #2980b9, #8e44ad);
  background-size: 400%;
  animation: bganimation 15s infinite;
}

.login_mask {
  width: 25%;
  height: 40%;
  margin: 12% 0 0 65%;
  overflow: hidden;
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.3);
  box-shadow: 10px 0 10px 0 rgba(255, 255, 255, 0.1)
}

@keyframes bganimation {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}

/* 登录框专属背景动画（慢速度+反向） */
@keyframes loginBgAnimation {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}
</style>
